module.exports = "<h2 class=\"not-found__label\"><span></span> Access not allowed</h2>"


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/defaults/not-allowed/not-allowed.component.html
// module id = ../../../../../angular/app/components/defaults/not-allowed/not-allowed.component.html
// module chunks = 1